import React from 'react';
import { Link } from '@/components/LocaleLink';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { homeCopy } from '@/contexts/language/translations/pages/home';

const ConsultingSection = () => {
  const { t, language } = useLanguage();
  const c = homeCopy[language].consulting;

  const services = [
    {
      title: t('consultingDataAdoptionTitle'),
      description1: t('consultingDataAdoptionDesc1'),
      description2: t('consultingDataAdoptionDesc2'),
    },
    {
      title: t('consultingAIReadinessTitle'),
      description1: t('consultingAIReadinessDesc1'),
      description2: t('consultingAIReadinessDesc2'),
    },
  ];

  return (
    <section id="consulting" className="py-20 bg-[#F5F5F7]">
      <div className="container-custom max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            <span className="text-foreground">{t('consultingTitlePrefix')}</span>
            <span className="text-[#FF6B35]">{t('consultingTitleHighlight')}</span>
          </h2>
          <p className="text-lg text-foreground">
            {t('consultingSubtitle')}
          </p>
        </div>

        {/* Service Cards - Two Columns */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="text-left bg-[#FFF8F0] rounded-lg p-6 md:p-8 flex flex-col"
            >
              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-4">
                {service.title}
              </h3>
              <p className="text-foreground leading-relaxed mb-4">
                {service.description1}
              </p>
              <p className="text-foreground leading-relaxed flex-grow">
                {service.description2}
              </p>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <Link
            to="/tell-me-more"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#FF6B35] text-white font-semibold hover:bg-[#FF6B35]/90 transition-colors"
          >
            {c.tellMeMore}
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ConsultingSection;

